var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-cell-content"
  }, [_c('div', {
    staticClass: "truncate-container",
    attrs: {
      "id": "reference-".concat(_vm._uid)
    },
    on: {
      "mouseenter": _vm.showTooltip,
      "mouseleave": _vm.hideTooltip,
      "focus": _vm.showTooltip,
      "blur": _vm.hideTooltip
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.truncatedText))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shouldShowTooltip && _vm.isHovering,
      expression: "shouldShowTooltip && isHovering"
    }],
    staticClass: "floating-tooltip",
    attrs: {
      "id": "tooltip-".concat(_vm._uid)
    }
  }, [_c('div', {
    staticClass: "popover",
    class: "bs-popover-".concat(_vm.placement)
  }, [_c('h3', {
    staticClass: "popover-header"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "popover-body"
  }, [_vm._v(_vm._s(_vm.content))]), _c('div', {
    staticClass: "arrow",
    attrs: {
      "id": "arrow-".concat(_vm._uid)
    }
  })])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }